import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDDisplayText } from '@facet-wealth/design';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: FDDisplayText,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: FDBodyText,
    _customProps: {
      align: 'center',
      size: 'lg',
    },
  }, overrideReadOnly);
